<template>
    <div class="text-center">
        <v-dialog width="600" v-model="dialog">
            <template v-slot:activator="{ on }">
                <v-btn class="ml-2" small outlined elevation="0" text v-on="on">
                    Рассылки<v-icon color="grey" right small>mdi-email-fast</v-icon>
                </v-btn>
            </template>
            <v-card class="px-3 py-5">
                <v-card-title class="headline" primary-title>Рассылки {{ this.profile.fullName }}
                </v-card-title>
                <v-card-text>

                    <div class="mt-3 d-flex align-center justify-space-between">
                        <v-col cols="4">
                            <div>
                                Подтверждение<v-icon right small>mdi-check-circle-outline</v-icon>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div>{{ this.profile.mailingConfirm }}</div>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-end">
                            <div>
                            <v-btn elevation="0" small color="primary" @click="
                                sendMails('confirm')
                            ">Запустить</v-btn>
                        </div>
                        </v-col>

                    </div>
                    <div class="mt-3 d-flex align-center justify-space-between">
                        <v-col cols="4">
                            <div>
                                Подтверждение 2 <v-icon right small>mdi-check-circle-outline</v-icon>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div>{{ this.profile.mailingConfirm2 }}</div>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-end">
                            <div>
                            <v-btn elevation="0" small  color="primary"  @click="
                                sendMails('confirm2')
                            ">Запустить</v-btn>
                        </div>
                        </v-col>

                    </div>
                    <div class="mt-3 d-flex align-center justify-space-between">
                        <v-col cols="4">
                            <div>
                                Приглашение<v-icon right small>mdi-cake</v-icon>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div>{{ this.profile.mailingInvite }}</div>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-end">
                            <div>
                            <v-btn elevation="0" small color="primary"  @click="
                                sendMails('invite')
                            ">Запустить</v-btn>
                        </div>
                        </v-col>

                    </div>
                </v-card-text>
            </v-card>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </v-dialog>
    </div>
</template>
<script>

import ConfirmDialogue from '../helpers/ConfirmDialogue.vue'

export default {
    data: function () {
        return {
            dialog: false,
            id: this.profile._id
        }
    },
    components: {
        ConfirmDialogue
    },
    props: ['profile', 'loadProfiles'],
    methods: {
        async sendMails(type) {
            const ok = await this.$refs.confirmDialogue.show({
                message: 'Вы уверены, что хотите начать рассылку?',
                okButton: 'Начать',
            })
            if (ok) {
                await this.$axios
                    .post('/api/send-mails/', {
                        _id: this.id,
                        type,
                        time: `${new Date().toLocaleString("ru-RU")}`
                    })
                this.$notify({
                    text: 'Рассылка начата'
                });
                this.loadProfiles()
            }
        }
    }
}

</script>
